import React from 'react';

import styles from './NoResults.scss';

function NoResults() {
  return (
    <div className={styles.noResults}>
      <div className={styles.noResultsTitle}>NO RESULTS FOUND</div>
      <div className={styles.noResultsSubtitle}>
        Try searching for something else...
      </div>
    </div>
  );
}

NoResults.propTypes = {};
NoResults.defaultProps = {};

export default NoResults;
